module.exports = __webpack_public_path__ + "img/char-hu-2.9501253a.png";